import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useFieldLayout } from '../hooks/useMedia';
import { ToolFund } from '../modules/ComponentsLibrary/ToolFund';
import { ToolFundRequestsPhone } from '../modules/ComponentsLibrary/ToolFund/phone/ToolFundRequestsPhone';

export const Route = createFileRoute('/toolFundRequests')({
  component: RouteComponent,
  // Phones and tablets open a request, and one of its tools, as pages: in the URL, so a refresh
  // keeps them and the phone's Back steps out. Desktop doesn't read these.
  validateSearch: z.object({
    request: z.coerce.number().int().positive().optional(),
    tool: z.coerce.number().int().positive().optional(),
  }),
  head(ctx) {
    return {
      meta: [{ title: 'Tool Fund Requests' }],
    };
  },
});

function RouteComponent() {
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    return <ToolFundRequestsPhone />;
  }
  return <ToolFund />;
}
